// extracted by mini-css-extract-plugin
module.exports = {"history_container":"history_history_container__23jTs flex_row","history_orders_container":"history_history_orders_container__3H133"};